import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { take } from 'rxjs';

import { selectCanPrintAuditTrail } from '../../app/state/selectors';

/**
 * Route guard for the Audit Trail print view. Entering the print outlet auto-triggers the browser
 * print dialog and records a Print entry server-side, so a pasted URL or back-navigation must not
 * be able to bypass the unsaved-changes check the Print View link performs.
 */
export const auditTrailPrintGuard: CanActivateFn = () => {
  const store = inject(Store);

  return store.select(selectCanPrintAuditTrail).pipe(take(1));
}
